import React from 'react'

export default function DocumentsGrid() {
  return (
    <div>
      
    </div>
  )
}
